export let environment = {
  backendUrl: process.env.REACT_APP_BACKEND_URL,
  blobImagesUrl: process.env.REACT_APP_BLOB_IMAGES_URL,
  auth: {
    tenant: process.env.REACT_APP_AUTH_TENANT,
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
    redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI,
  },
  disableAuth: process.env.REACT_APP_DISABLE_AUTH?.toLowerCase() === "true"
};
